/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'xrx-checkbox',
  templateUrl: './xrx-checkbox.component.html',
  styleUrls: ['./xrx-checkbox.component.less'],
  standalone: false,
})
export class XrxCheckboxComponent {
  @Input() checkBoxValue: boolean;
  @Input() name = 'checkbox';
  @Input() label: string;
  @Input() isDisabled = false;
  @Input() isPartial = false;

  @Output() toggle = new EventEmitter<boolean>();
  @Output() checkBoxValueChange = new EventEmitter<boolean>();
  @Output() isPartialChange = new EventEmitter<boolean>();

  onToggle() {
    if (!this.isDisabled) {
      this.checkBoxValue = !this.checkBoxValue;
      this.checkBoxValueChange.emit(this.checkBoxValue);
      this.toggle.emit(this.checkBoxValue);
    }
  }
}
